"use client";

import { useLocale } from "next-intl";
import { useTranslations } from "next-intl";
import type { CodeExample } from "../content/types";
import { cn } from "@/lib/utils";

type Props = {
  examples: CodeExample[];
  onTry: (example: CodeExample) => void;
};

export function CodeExampleCards({ examples, onTry }: Props) {
  const t = useTranslations("playground");
  const uiLocale = useLocale();
  const loc = uiLocale === "bn" ? "bn" : "en";

  return (
    <section aria-labelledby="pg-examples" className="mt-12 space-y-4">
      <h2 id="pg-examples" className="text-lg font-semibold text-[#FFAB8F]">
        {t("seoCodeExamplesTitle")}
      </h2>
      <p className="text-sm text-white/60">{t("seoCodeExamplesSubtitle")}</p>
      <ul className="grid gap-3 sm:grid-cols-2">
        {examples.map((ex) => (
          <li
            key={ex.id}
            className="flex flex-col rounded-xl border border-white/10 bg-[#141416]/90 p-4 shadow-inner"
          >
            <h3 className="font-medium text-white">{ex.title[loc]}</h3>
            <pre
              className="mt-2 max-h-28 overflow-auto rounded-lg border border-white/10 bg-[#0B0B0C] p-2 text-[11px] leading-snug text-white/75"
              tabIndex={0}
            >
              <code>{ex.code.trim()}</code>
            </pre>
            <button
              type="button"
              onClick={() => onTry(ex)}
              className={cn(
                "mt-3 inline-flex w-full items-center justify-center rounded-lg px-3 py-2 text-sm font-semibold text-white transition",
                "bg-gradient-to-r from-[#E94D1D] via-[#f05a28] to-[#FFAB8F] hover:brightness-110",
              )}
            >
              {t("tryThis")}
            </button>
          </li>
        ))}
      </ul>
    </section>
  );
}
